// extracted by mini-css-extract-plugin
export default {"favButton":"FavoriteButton_favButton__Io5VJ","starHolder":"FavoriteButton_starHolder__fnaLn","star":"FavoriteButton_star__5nOeb","visible":"FavoriteButton_visible__v8ZgB"};